import clsx from 'clsx'
import React, {PropsWithChildren, useState} from 'react'

import LogoRuIcon from '../components/icons/LogoRuIcon'
import {headerClasses} from './Header@mobile.classes'

export function Header({children}: PropsWithChildren<{}>): React.ReactElement {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <div className={clsx(headerClasses.mobileHeader, {[headerClasses.active]: isMenuOpen})}>
      <header className={headerClasses.secondLine}>
        <a className={headerClasses.logoLink} href="/" title="">
          <LogoRuIcon className={headerClasses.logo} />
        </a>
        <div className={headerClasses.headerButtonsContainer}>
          <div
            className={clsx(headerClasses.menuButton, {[headerClasses.active]: isMenuOpen})}
            onClick={() => setIsMenuOpen(isOpen => !isOpen)}
          >
            <span />
          </div>
        </div>
      </header>
      <nav className={clsx(headerClasses.nav, {[headerClasses.active]: isMenuOpen})}>{children}</nav>
    </div>
  )
}
